import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { BiSolidPrinter } from "react-icons/bi"
import api from "../../api";
import { Form, Input, Button } from "../../components/index"
import styles from "./style.module.css";
import { ConferenceSchoolCheckboxGroup } from "../../components"
import { useSchools } from "../../components/utils"


const UserList = () => {
    const { value: tagsValue, handleChange: handleTagsChange, setValue: setTagsValue } = useSchools()
    const [peoplePage, setPeoplePage] = useState(1)
    const [peopleList, setPeopleList] = useState([])
    const [peopleCount, setPeopleCount] = useState(0)

    const [schools, setSchools] = useState([])
    const [counter, setCounter] = useState(0)

    const [schoolName, setSchoolName] = useState('')
    const [fio, setFio] = useState('')
    const [region, setRegion] = useState('')
    const [jobPlace, setJobPlace] = useState('')
    const [job, setJob] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [countStep, setCountStep] = useState(1)


    const [submitting, setSubmitting] = useState(false);
    const [nextStep, setNextStep] = useState(false)
    const [agree, setAgree] = useState(false)
    const [animated, setAnimated] = useState(false);


    const reset = () => {
        setSubmitting(false)
        setCountStep(1)
        setNextStep(false)
    }

    const next = () => {
        setNextStep(true)
        setCountStep(2)
    }

    const back = () => {
        setNextStep(false)
        setSchoolName("")
        setCountStep(1)
        setSchoolName("")
        setFio("")
        setRegion("")
        setJobPlace("")
        setJob("")
        setPhone("")
        setEmail("")
    }

    const checkIfDisabledLite = () => {
        return schoolName === ''
    }

    const checkAgree = () => {
        return !agree ||
            fio === '' ||
            region === '' ||
            jobPlace === '' ||
            job === '' ||
            phone === '' ||
            email === ''
    }

    useEffect(() => {
        api.getConferences()
            .then((data) => {
                setSchools(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);


    const getNews = ({ page = 1, tags }) => {
        api.getRegistrationUsers({ page, tags })
            .then(res => {
                const { result, count } = res
                setPeopleList(res)
                setPeopleCount(count)
            })
    }

    useEffect(_ => {
        getNews({ page: peoplePage, tags: tagsValue })
    }, [peoplePage, tagsValue])


    useEffect(_ => {
        api.getConferences()
            .then(tags => {
                setTagsValue(tags.results.map((conference) => (conference.conference_school?.map((tag) => ({ ...tag, value: true })))))
            })
    }, []);
    return (
        <>
            <>
                <Form
                    className={styles.form}
                    onSubmit={e => {
                        e.preventDefault()
                        const data = {
                            school_name: schoolName,
                            fio: fio,
                            region: region,
                            job_place: jobPlace,
                            job: job,
                            phone: phone,
                            email: email
                        }
                        setSubmitting(true)
                        setCountStep(3)
                        setCounter(counter + 1)
                        setAnimated(true)
                        setSchoolName("")
                        setFio("")
                        setRegion("")
                        setJobPlace("")
                        setJob("")
                        setPhone("")
                        setEmail("")
                        setAgree(false)
                        api
                            .registrationConference(data)
                    }}
                >
                    <>
                        <>
                            <Input
                                required
                                label='ФИО'
                                name='fio'
                                onChange={e => {
                                    const value = e.target.value
                                    setFio(value)
                                }}
                                value={fio}
                            />
                            <Input
                                required
                                label='Регион'
                                name='region'
                                onChange={e => {
                                    const value = e.target.value
                                    setRegion(value)
                                }}
                                value={region}
                            />
                            <Input
                                required
                                label='Учреждение'
                                name='jobPlace'
                                onChange={e => {
                                    const value = e.target.value
                                    setJobPlace(value)
                                }}
                                value={jobPlace}
                            />
                            <Input
                                required
                                label='Должность'
                                name='job'
                                onChange={e => {
                                    const value = e.target.value
                                    setJob(value)
                                }}
                                value={job}
                            />
                            <Input
                                required
                                label='Контактный телефон'
                                name='phone'
                                onChange={e => {
                                    const value = e.target.value
                                    setPhone(value)
                                }}
                                value={phone}
                            />
                            <Input
                                required
                                label='Email'
                                name='email'
                                onChange={e => {
                                    const value = e.target.value
                                    setEmail(value)
                                }}
                                value={email}
                            />

                            {schools.results?.map((conference, index) => {
                                return (
                                    <>
                                        <div className={styles.radioArea} key={index}>
                                            {conference.conference_school?.map((school, index) => {
                                                return (
                                                    <div key={index}>
                                                        <Input
                                                            required
                                                            label={school.name}
                                                            name="schoolName"
                                                            type="radio"
                                                            onChange={e => {
                                                                const value = e.target.value
                                                                setSchoolName(value)
                                                            }}
                                                            value={school.id}
                                                            id={school.id}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </>
                                )

                            })}
                            <Button
                                modifier='style_dark-blue'
                                className={styles.button}
                                type="submit"

                            >
                                Зарегистрироваться
                            </Button>
                        </>
                    </>

                </Form>
            </>
            <ConferenceSchoolCheckboxGroup
                newsList={peopleList}
                values={tagsValue}
                handleChange={value => {
                    handleTagsChange(value)
                }}
            />
            <table>
                <thead>
                    <tr>
                        <th>ФИО</th>
                        <th>Регион</th>
                        <th>Учреждение</th>
                        <th>Должность</th>
                        <th>Телефон</th>
                        <th>Email</th>
                        <th>Печать</th>
                    </tr>
                </thead>
                {peopleList.results?.map((people) => {
                    return (
                        <tbody>
                            <tr>
                                <td>{people.fio}</td>
                                <td>{people.region}</td>
                                <td>{people.job_place}</td>
                                <td>{people.job}</td>
                                <td>{people.phone}</td>
                                <td>{people.email}</td>
                                <td className={styles.print}>
                                    <Link
                                        to={`/api/registration/${people.id}/generate_file`}
                                        target="_blank"
                                    >
                                        <BiSolidPrinter />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    )
                })}
            </table>
        </>
    );
}

export default UserList;